import _ from "lodash";


import { ICurrencyConfig } from "src/constants/interfaces";
import { decimalString } from "src/constants/types";

export const factorial = _.memoize((x: number): number => (
  x <= 0 ? 1 : (x * factorial(x - 1))
));

export const permutation = (n: number, m: number) => {
  return factorial(n) / (factorial(n - m) * factorial(m));
}

export const splitFractionalPart = (num: number) => {
    const [intPart, fractionPart] = num.toString().split('.');

    if (!fractionPart) return num;

    // Avoids: 8.2 * 100 = 819.9999999999999
    if (fractionPart.length > 1)
        return parseInt(fractionPart.substr(0, 2)) === 99 ? parseInt(intPart) + 1 : parseInt(intPart);

    return Math.floor(num);
};

export const roundAmount = (amount: number, currencyConfig?: ICurrencyConfig, keepDecimalZeros = true ) => (
    keepDecimalZeros
        ? amount.toFixed(currencyConfig?.rounding ?? 2)
        : `${parseFloat(amount.toFixed(currencyConfig?.rounding || 2))}`
) as decimalString;